import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="drawer"
//
// The mobile bottom-sheet variant of AppUi::FilterDrawer (below `lg` — see
// the desktop variant's own "modal filter-drawer" pair in
// app_ui/filter_drawer/component.html.erb). One fixed height today, not a
// draggable multi-snap sheet, so this mirrors Modal/Slideover's own
// open/close/backdrop wiring rather than reimplementing gesture handling.
//
// `_mobile_filter_trigger` reaches this controller by a well-known element
// id (`window.Stimulus.getControllerForElementAndIdentifier(...)`) rather
// than a `data-action`, because the trigger button lives in a page's body
// toolbar while the drawer itself is rendered once at the bottom of the
// page — see that partial's own comment for why.
export default class extends Controller {
  static targets = [ "dialog" ]

  connect() {
    document.addEventListener("turbo:before-cache", this.closeBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.closeBeforeCache)
    document.body.style.overflow = ""
  }

  // Called from outside via getControllerForElementAndIdentifier — see the
  // trigger partial's comment. showModal() (not show()) is what gives the
  // dialog its native ::backdrop, which railsblocks.css dims and which
  // backdropClose below relies on.
  show(event) {
    if (event) event.preventDefault()

    this.dialogTarget.showModal()
    document.body.style.overflow = "hidden"
    this.dialogTarget.removeAttribute("data-closing")
    this.dispatch("opened")
  }

  close(event) {
    if (event) event.preventDefault()

    this.dialogTarget.setAttribute("data-closing", "")

    window.setTimeout(() => {
      this.dialogTarget.close()
      this.dialogTarget.removeAttribute("data-closing")
      document.body.style.overflow = ""
      this.dispatch("closed")
    }, 200) // matches railsblocks.css's --overlay-motion-duration-exit
  }

  // Only dismiss when the click lands on the dialog's own backdrop, not the
  // sheet content sitting inside it (docs/agent-conventions.md's Modal
  // pattern — same check as modal_controller/slideover_controller).
  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close(event)
    }
  }

  // The native "cancel" event (Escape key).
  cancel(event) {
    event.preventDefault()
    this.close()
  }

  closeBeforeCache = () => {
    if (this.dialogTarget.open) {
      this.dialogTarget.close()
      document.body.style.overflow = ""
    }
  }
}
